import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import React from "react";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import NotificationListRow from "./NotificationListRow";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Notification = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const last3DaysApplications = useSelector(
    (state) => state.adminDash.companyStatistics?.last3DaysFinishedApplications
  );

  const reversedLast3DaysApplications = last3DaysApplications?.slice().reverse();

  return (
    <Card className={"default-list with-shadow pb-3"}>
      <Card className={"header"}>
        <Row className={"text-20 text-color-gray-light fw-medium mx-0"} style={{ height: "50px" }}>
          <Col xs={6} lg={4} className={"align-content-center p-0"}>
            <Row>
              <Col xs={2}></Col>
              <Col xs={10} className={"ps-4"}>
                {t("notificationCandidateNameHeader")}
              </Col>
            </Row>
          </Col>
          <Col xs={6} lg={4} className={"align-content-center"}>
            <Row className={"justify-content-center"}>{t("notificationStatusHeader")}</Row>
          </Col>
          <Col xs={4} className={"align-content-center d-none d-lg-block"}>
            <Row className={"me-5 justify-content-end"}>
              <Col xs={"auto"}>{t("notificationTimeHeader")}</Col>
            </Row>
          </Col>
        </Row>
      </Card>

      <ScrollableCard top={0} bottom={40} emptySpaceHeight={50}>
        {reversedLast3DaysApplications?.map((notification, i) => {
          const lastItem = i === reversedLast3DaysApplications.length - 1;
          return (
            <Card key={i} className={`list-row ${(last3DaysApplications?.length < 1 || lastItem) && "border-0"}`}>
              <NotificationListRow notification={notification} />
            </Card>
          );
        })}

        {last3DaysApplications?.length < 1 && (
          <Card className={"list-row border-0"}>
            <div className={"p-0 mb-3"} style={{ backgroundColor: "#f7f7f7", borderRadius: "10px" }}>
              <Row
                className={"justify-content-center text-25 text-color-gray-light fw-medium"}
                style={{ height: "50px" }}
              >
                <Col xs={"auto"} className={"align-content-center"}>
                  {t("notificationEmptyStateMessage")}
                </Col>
              </Row>
            </div>
          </Card>
        )}
      </ScrollableCard>
    </Card>
  );
};

export default Notification;
